// Mirror of baseapi/constants/api_key_scopes.go. Keep in sync — the backend
// is the authoritative validator, but the frontend lists the same catalog so
// admins see exactly the scopes the server accepts.

export const SCOPE_READ_ALL = 'read:all';
export const SCOPE_READ_CONTENT = 'read:content';
export const SCOPE_READ_CALENDAR = 'read:calendar';
export const SCOPE_READ_WORKSPACE = 'read:workspace';

export interface ScopeOption {
  value: string;
  label: string;
  description: string;
}

export const SCOPE_CATALOG: ScopeOption[] = [
  {
    value: SCOPE_READ_ALL,
    label: 'Full read access (read:all)',
    description: 'Legacy wildcard. Grants every read scope. Prefer specific scopes for new keys.',
  },
  {
    value: SCOPE_READ_CONTENT,
    label: 'Content (read:content)',
    description: 'Read content types, individual content items, and collections.',
  },
  {
    value: SCOPE_READ_CALENDAR,
    label: 'Calendar (read:calendar)',
    description: 'Read calendar events.',
  },
  {
    value: SCOPE_READ_WORKSPACE,
    label: 'Workspace metadata (read:workspace)',
    description: 'Read workspace info and sport types.',
  },
];

export function describeScope(value: string): string {
  return SCOPE_CATALOG.find((s) => s.value === value)?.label ?? value;
}
